import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SysUsersService } from '../services/sys-users.service';

@Component({
  selector: 'ngx-new-sys-users',
  templateUrl: './new-sys-users.component.html',
  styleUrls: ['./new-sys-users.component.scss'],
})
export class NewSysUsersComponent implements OnInit {
  @Input() stationId: any;
  @Input() stationsUser: Array<any>;
  loading: boolean = false;
  user = {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'superadmin',
    pickPasswordFormMe: false,
    stations: [],
  };

  constructor(
    protected ref: NbDialogRef<NewSysUsersComponent>,
    private sysUsersService: SysUsersService,
  ) { }

  ngOnInit() {
  }

  close() {
    this.ref.close();
  }

  async createUser() {

    if (!this.user.stations.length) {
      return Swal.fire({
        icon: 'error',
        title: 'Debe seleccionar al menos una estacion',
        text: '',
      });
    }

    if (this.user.pickPasswordFormMe === true) {
      this.user.password = 'holaMundoAmigos';
      this.user.confirmPassword = 'holaMundoAmigos';
    }

    if (this.user.pickPasswordFormMe === false && this.user.password !== this.user.confirmPassword) {
      return Swal.fire({
        icon: 'error',
        title: 'Las contraseñas no coinciden',
        text: '',
      });
    }

    const validDataHasEmptyFields = Object.values(this.user).includes('');

    if (validDataHasEmptyFields) {

      this.user.password = '';
      this.user.confirmPassword = '';

      return Swal.fire({
        icon: 'error',
        title: 'Ingresa todos los datos necesiarios',
        text: '',
      });
    }

    this.loading = true;
    const [error, result] = await this.sysUsersService.storeUser(this.user) as any;
    // tslint:disable-next-line: max-line-length
    if (error) {
      this.loading = false;
      if (error.status === 400) {
        return Swal.fire({
          icon: 'error',
          title: 'Este usuario ya existe, intenta con otro email',
          text: '',
        });
      }
      return Swal.fire({
        icon: 'error',
        title: 'Ocurrió un error al intentar guarda la información. Intenta más tarde',
        text: '',
      });
    }
    this.alert(result.data, 'Usuario guardado con éxito');
    this.ref.close(true);
  }


  alert(user, title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      html:
        `Email: <b>${user.email}</b> </br>` +
        `Contraseña: <b>${user.password}</b>`,
      title: title,
      text: text,
    });
  }
}
